import AppLayout from "@/layouts/app/AppLayout";

import dashboard from "./dashboard"

export default [
  

  {
    path: "/buyer",
    component: AppLayout,
    meta: {
      middleware: ["auth"],
      roles: ["buyer"],
    },
    children: [
        ...dashboard,
    ],
  },
];
